<template>
  <div class="handheld">
    <label class="handheld__focus" @click="$refs.input.focus()">
      <input class="handheld__input" ref="input" v-model="input" @keypress="onInput" @focus="focus" @blur="blur"
             autofocus/>
      <span class="handheld__focus-text" v-if="state==='loading'">Загружаем...</span>
      <span class="handheld__focus-text" v-else-if="hasFocus">Можно сканировать</span>
      <span class="handheld__focus-text" v-else>Нажмите сюда</span>
    </label>

    <div class="handheld__output" v-if="input">
      <b v-if="!isCorrectLayout" class="handheld__output-note">Переключите раскладку на английскую!</b>
      <a :href="input" v-else-if="inputIsUrl" class="handheld__output-data">{{ input }}</a>
      <span v-else-if="!inputIsUrl" class="handheld__output-data">{{ input }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HandheldScanner',
  props: {
    state: String
  },
  data() {
    return {
      input: null,
      hasFocus: false
    }
  },
  methods: {
    focus() {
      this.hasFocus = true
      this.$emit('focus')
    },
    blur() {
      this.hasFocus = false
      this.$emit('blur')
    },
    onInput(e) {
      if (this.state === 'loading') return
      if (['Enter', 'Tab'].includes(e.key) && this.isCorrectLayout) {
        console.log('input finished')
        this.$emit('detect', this.input)
      }
    }
  },
  computed: {
    isCorrectLayout() {
      return !(/[А-Яа-я]/.test(this.input));
    },
    inputIsUrl() {
      return /^http(s)?:\/\/.+/.test(this.input)
    }
  },
  watch: {
    state(val) {
      if (val.startsWith('idle')) this.input = null
    }
  }
}
</script>

<style lang="less" scoped>
.handheld {
  position: relative;
  margin: auto;

  &__focus {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 80vw;
    max-width: 270px;
    height: 120px;
    box-shadow: 0 0 0 2px currentColor inset;
    border-radius: 15px;
    cursor: pointer;
    transition-duration: .2s;
    opacity: .7;

    &:focus-within {
      box-shadow: 0 0 0 4px var(--accent) inset;
      color: var(--accent);
      opacity: 1;
    }

    span {
      font-weight: 700;
      font-size: 18px;
    }
  }

  &__input {
    position: absolute;
    top: -9999px;
    left: -9999px;
    opacity: 0;
  }

  &__output {
    font-size: 13px;
    line-height: 1.5;
    font-weight: 600;
    margin-top: 10px;

    &-data {
      word-break: break-all;
    }

    a {
      text-decoration: underline;
    }
  }
}

@keyframes blink {
  from {
    opacity: .2;
  }
}
</style>
